/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Event } from '../models/Event';
import type { EventApplication } from '../models/EventApplication';
import type { UserApplication } from '../models/UserApplication';
import type { UserData } from '../models/UserData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EventService {

    /**
     * Create Event API Endpoint
     * Create Event
     * @param xAccessToken 
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createEvent(
xAccessToken: string,
requestBody: {
imageUrl: string;
title: string;
description: string;
areaId: number;
categoryId: number;
startTime: string;
finishTime: string;
type: string;
applicationDeadline: string;
applicationMax?: number;
linkUrl?: string;
archiveVideoUrl?: string;
address?: string;
isFree?: boolean;
price?: number;
adviserId?: number;
contactInfo: string;
status?: string;
isPublic?: boolean;
isApplicationEnable?: boolean;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Event;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/event',
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * List Event API Endpoint
     * List Event
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param category 
     * @param adviserId 
     * @param type 
     * @param status 
     * @param startDate 
     * @param sortOrder 
     * @param orderBy 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listEvent(
xAccessToken?: string,
offset?: number,
limit?: number,
area?: string,
category?: string,
adviserId?: number,
type?: string,
status?: string,
startDate?: string,
sortOrder?: string,
orderBy?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
events?: Array<Event>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/event',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'category': category,
                'adviserId': adviserId,
                'type': type,
                'status': status,
                'startDate': startDate,
                'sortOrder': sortOrder,
                'orderBy': orderBy,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Event Details API Endpoint
     * Get Event Details
     * @param eventId ID of event to return
     * @param xAccessToken 
     * @returns any successful operation
     * @throws ApiError
     */
    public static getEventDetails(
eventId: number,
xAccessToken?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: Event;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/event/{eventID}',
            path: {
                'eventID': eventId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Bad Request`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Event API Endpoint
     * Update Event
     * @param xAccessToken 
     * @param eventId ID of event to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateEvent(
xAccessToken: string,
eventId: number,
requestBody: {
imageUrl?: string;
title?: string;
description?: string;
areaId?: number;
categoryId?: number;
startTime?: string;
finishTime?: string;
type?: string;
applicationDeadline?: string;
applicationMax?: number;
linkUrl?: string;
archiveVideoUrl?: string;
address?: string;
isFree?: boolean;
price?: number;
adviserId?: number;
contactInfo?: string;
status?: string;
isArchivePublic?: boolean;
isPublic?: boolean;
isApplicationEnable?: boolean;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Event;
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/event/{eventID}',
            path: {
                'eventID': eventId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Delete Event API Endpoint
     * Delete Event
     * @param xAccessToken 
     * @param eventId ID of event to delete
     * @returns any successful operation
     * @throws ApiError
     */
    public static deleteEvent(
xAccessToken: string,
eventId: number,
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/event/{eventID}',
            path: {
                'eventID': eventId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Create Proxy Application API Endpoint
     * Create Proxy Application
     * @param xAccessToken 
     * @param eventId ID of event to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createProxyApplication(
xAccessToken: string,
eventId: number,
requestBody: {
type: string;
count: number;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Array<EventApplication>;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/event/{eventID}/proxy_application',
            path: {
                'eventID': eventId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                406: `Not Acceptable`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Create Event Application API Endpoint
     * Create Event Application
     * @param xAccessToken 
     * @param eventId ID of event to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createEventApplication(
xAccessToken: string,
eventId: number,
requestBody: {
type: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: {
application?: EventApplication;
user?: UserData;
};
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/event/{eventID}/application',
            path: {
                'eventID': eventId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                406: `Not Acceptable`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Event Application API Endpoint
     * Get Event Application
     * @param xAccessToken 
     * @param eventId ID of event to return
     * @param applicationId ID of application to return
     * @returns any successful operation
     * @throws ApiError
     */
    public static getEventApplication(
xAccessToken: string,
eventId: number,
applicationId: number,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
application?: EventApplication;
user?: UserData;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/event/{eventID}/application/{applicationID}',
            path: {
                'eventID': eventId,
                'applicationID': applicationId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Event Application API Endpoint
     * Update Event Application
     * @param xAccessToken 
     * @param eventId ID of event to return
     * @param applicationId ID of application to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateEventApplication(
xAccessToken: string,
eventId: number,
applicationId: number,
requestBody: {
status: string;
rejectReason?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: {
application?: EventApplication;
user?: UserData;
};
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/event/{eventID}/application/{applicationID}',
            path: {
                'eventID': eventId,
                'applicationID': applicationId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * List User Applications API Endpoint
     * List User Applications
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param category 
     * @param updatedAt 
     * @param sortOrder 
     * @param orderBy 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listUserApplications(
xAccessToken: string,
offset?: number,
limit?: number,
area?: string,
category?: string,
updatedAt?: string,
sortOrder?: string,
orderBy?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
applications?: Array<UserApplication>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/application',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'category': category,
                'updatedAt': updatedAt,
                'sortOrder': sortOrder,
                'orderBy': orderBy,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Export Event User List API Endpoint
     * Export Event User List
     * @param eventId ID of event to return
     * @param xAccessToken 
     * @returns binary successful operation
     * @throws ApiError
     */
    public static exportEventUserList(
eventId: number,
xAccessToken?: string,
): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/event/{eventID}/export',
            path: {
                'eventID': eventId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

}
